'use client'

import type { Route } from 'next'
import { useRouter } from 'next/navigation'
import { Briefcase, ChevronRight } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { CaseStatusBadge, FlowBadge, SERVICE_TYPE_TO_FLOW } from '@/features/cases'
import type { InvestorCase } from '@/features/investors'
import { SERVICE_META } from '@/features/investor/components/home/service-meta'

export function ServicesListCard({ cases }: { cases: InvestorCase[] }) {
  const router = useRouter()

  if (cases.length === 0) return null

  return (
    <Card>
      <CardHeader className="flex flex-row items-start gap-3 space-y-0">
        <span className="bg-primary/10 text-primary flex size-9 shrink-0 items-center justify-center rounded-lg">
          <Briefcase className="size-4" />
        </span>
        <div>
          <CardTitle className="text-base font-medium">Your services</CardTitle>
          <CardDescription>Where every request you&apos;ve made stands right now.</CardDescription>
        </div>
      </CardHeader>
      <CardContent className="flex flex-col gap-2">
        {cases.map((c) => {
          const flow = SERVICE_TYPE_TO_FLOW[c.serviceType]
          return (
            <button
              key={c.id}
              type="button"
              onClick={() => router.push(SERVICE_META[flow].tabRoute as Route)}
              className="hover:bg-muted/40 flex w-full flex-wrap items-center justify-between gap-2 rounded-lg border px-3.5 py-2.5 text-left transition-colors disabled:cursor-default disabled:hover:bg-transparent"
            >
              <div className="flex min-w-0 items-center gap-2.5">
                <FlowBadge flow={flow} />
                <span className="truncate text-sm font-medium">{c.reference}</span>
              </div>
              <div className="flex shrink-0 items-center gap-2">
                <CaseStatusBadge status={c.caseStatus} />
                <ChevronRight className="text-muted-foreground size-4 shrink-0" />
              </div>
            </button>
          )
        })}
      </CardContent>
    </Card>
  )
}
